import { api } from '../api';
import { GameDto } from './parameters-types';
import { Prisma, RakeStructure } from '@repo/common-types';
import RakeStructureCreateInput = Prisma.RakeStructureCreateInput;

export const blindCreateStructureRest = async (blindDto: RakeStructureCreateInput) => {
  const response = await api.post<RakeStructure>(`/v1/blind-structures`, blindDto);
  return response.data;
};

export const blindUpdateStructureRest = async (rakeDto: RakeStructure): Promise<RakeStructure> => {
  const response = await api.put<RakeStructure>(`/v1/blind-structures/${rakeDto.id}`, rakeDto);
  return response.data;
};

export const blindStructureRest = async (rakeStructureId: string): Promise<RakeStructure> => {
  const response = await api.get<RakeStructure>(`/v1/blind-structures/${rakeStructureId}`);
  return response.data;
};

export const blindStructuresRest = async (): Promise<RakeStructure[]> => {
  const response = await api.get<RakeStructure[]>(`/v1/blind-structures`);
  return response.data;
};

export const getGameRest = async (gameId: string) => {
  const response = await api.get<GameDto>(`/v1/mixed-games/${gameId}`);
  return response.data;
};

export const getGamesRest = async () => {
  const response = await api.get<GameDto[]>(`/v1/mixed-games`);
  return response.data;
};
